/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ d: NonNullable<unknown>, h: NonNullable<unknown> }} Pumps_Permutation_Text_1Inputs */



/**
* | output |
* | --- |
* | "Double pumps swap every {d} to {h}h" |
*
* @param {Pumps_Permutation_Text_1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const pumps_permutation_text_1 = /** @type {((inputs: Pumps_Permutation_Text_1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pumps_Permutation_Text_1Inputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Double pumps swap every ${i?.d} to ${i?.h}h`)
	return /** @type {LocalizedString} */ (`Les pompes doubles permutent tous les ${i?.d} à ${i?.h}h`)
});